/* eslint-disable no-console, react/prop-types */
import React, { useState, useContext } from "react";
import axios from "axios";

import {
  Combobox,
  Icon,
  comboboxFilterAndLimit,
  IconSettings,
} from "@salesforce/design-system-react";

import { MappingsContext } from "../context/mappingsContext";
import { AppContext } from "../context/appContext";

const ObjectSelect = (props) => {
  const [inputValue, setInputValue] = useState("");
  const {
    selectedSalesforceObjects,
    setSelectedSalesforceObjects,
    availableSalesforceObjects,
  } = useContext(MappingsContext);

  const { jwt } = useContext(AppContext);

  const availableSalesforceObjectsWithIcon = availableSalesforceObjects.map(
    (elem) => ({
      ...elem,
      ...{
        icon: (
          <Icon
            assistiveText={{ label: elem.label }}
            category="standard"
            name={elem.iconType}
          />
        ),
      },
    })
  );

  const selectedSalesforceObjectsWithIcon = selectedSalesforceObjects.map(
    (elem) => ({
      ...elem,
      ...{
        icon: (
          <Icon
            assistiveText={{ label: elem.label }}
            category="standard"
            name={elem.iconType}
          />
        ),
      },
    })
  );

  return (
    <IconSettings iconPath="/icons">
      <Combobox
        id="combobox-base"
        disabled={props.disabled}
        events={{
          onChange: (event, { value }) => {
            setInputValue(value);
          },
          onRequestRemoveSelectedOption: (event, data) => {
            console.log(
              "REMOVED SALSFORCE OBJECT: clientside",
              data,
              selectedSalesforceObjects
            );
            // remove salesforce object clientside
            const removeSelectedSalesforceObject = selectedSalesforceObjects.filter(
              (n) => !data.selection.map((x) => x.id).includes(n.id)
            )[0];
            console.log(
              "removeSelectedSalesforceObject",
              removeSelectedSalesforceObject
            );
            // call api
            const removeSalesforceObject = async () => {
              try {
                const result = await axios({
                  method: "delete",
                  url: `/api/salesforce_objects/${removeSelectedSalesforceObject.id}`,
                  data: {
                    jwt: jwt,
                  },
                });
                console.log("REMOVED SALSFORCE OBJECT: api");
                console.log(`url: /api/salesforce_objects`);
                console.log(result);
                setSelectedSalesforceObjects(data.selection);
              } catch (error) {
                console.log(error);
              }
            };
            removeSalesforceObject();
            setInputValue("");
          },
          onSubmit: (event, { value }) => {
            console.log("onSubmit", event, value);
          },
          onSelect: (event, data) => {
            console.log("LAST ELEMENT ADDED", data);
            console.log(data.selection[data.selection.length - 1]);
            const createSalesforceObject = async () => {
              try {
                const result = await axios({
                  method: "post",
                  url: `/api/salesforce_objects`,
                  data: {
                    jwt: jwt,
                    name: data.selection[data.selection.length - 1].name,
                    pluginObjectId: props.pluginObjectId,
                  },
                });
                console.log("CREATED SALSFORCE OBJECT");
                console.log(`url: /api/salesforce_objects`);
                console.log(result);
                // updated id
                console.log({ ...data });
                data.selection[
                  data.selection.length - 1
                ].id = result.data.id.toString();
                console.log(data);
                setSelectedSalesforceObjects(data.selection);
              } catch (error) {
                console.log(error);
              }
            };
            createSalesforceObject();
          },
        }}
        labels={{
          label: "Salesforce Object",
        }}
        options={comboboxFilterAndLimit({
          inputValue: inputValue,
          options: availableSalesforceObjectsWithIcon,
          selection: selectedSalesforceObjectsWithIcon,
        })}
        selection={selectedSalesforceObjectsWithIcon}
        value={
          selectedSalesforceObjectsWithIcon.length
            ? selectedSalesforceObjectsWithIcon[0].label
            : inputValue
        }
        variant="inline-listbox"
        predefinedOptionsOnly={true}
        {...props}
      />
    </IconSettings>
  );
};

ObjectSelect.displayName = "ComboboxExample";

export default ObjectSelect;
